import { Box, Typography } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { EmptyMatchedStateIcon } from '../../../../../../components/icons'
import { AppDispatch } from '../../../../../../store'
import { RejectedGrantsActions, RejectedGrantsSelector } from '../../../../../../store/technology'
import { EmptyState, GrantsTable } from '../../sharedComponents'
import { TablePaging } from './TablePaging'

const Table_Headers = [
  'Grant Name',
  'Funding Agency',
  'Amount',
  'Type',
  'Due Date',
  'Accept/Reject',
]

export const RejectedGrants: React.FC = () => {
  const { projectId = '' } = useParams()

  const dispatch = useDispatch<AppDispatch>()

  const paging = useSelector(RejectedGrantsSelector.getPaging)
  const grants = useSelector(RejectedGrantsSelector.makeRejectedGrants)

  const fetchGrants = useCallback(() => {
    if (projectId) {
      const options = {
        params: {
          $limit: paging.limit,
          $skip: paging.skip,
          $sort: `createdAt -1`,
          $includes: 'grant,solicitation',
        },
      }

      dispatch(
        RejectedGrantsActions.fetchRejectedGrantsAsync({
          id: projectId,
          options,
        }),
      )
    }
  }, [paging.limit, paging.skip, projectId, dispatch])

  useEffect(() => {
    fetchGrants()
  }, [fetchGrants])

  const EmptyComponent = (
    <EmptyState
      message={<>You currently don't have any rejected grants.</>}
      icon={EmptyMatchedStateIcon}
    />
  )

  return (
    <Box p={2}>
      <Typography color="secondary" fontSize="1.3rem" fontWeight={600}>
        Rejected grants
      </Typography>

      <Box sx={{ backgroundColor: 'white' }}>
        <GrantsTable
          grants={grants}
          currentTab="Rejected"
          projectId={projectId}
          fetchGrants={fetchGrants}
          tableHeader={Table_Headers}
          emptyComponent={EmptyComponent}
        />

        <TablePaging />
      </Box>
    </Box>
  )
}
